import React, { useEffect, useState } from 'react';
import AnimatedPage from "../../components/AnimatedPage";
import { getRequest } from "../../config";
import BillingCard from "../../components/billing/card";

export default function Billing() {
	const [companies, setCompanies] = useState([])
	let [loading, setLoading] = useState(false);

	useEffect(() => {
		if (companies.length === 0) getBillings();
	}, []);

	const getBillings = async () => {
		setLoading(true)
		let response = await getRequest(`/payment/payment-history`, 'return-response');
		if (response['code'] == '200' && response['body']) {
			setCompanies(response['body']);
		} else {
			setCompanies([]);
		}
		setLoading(false)
	};

	return (
		<AnimatedPage>
			<div className="py3rem bg38 df aic fdc mih100vh">
				<div className="df fdc aic jcc w100 mb2rem">
					<h1 className="w100 c15 fs2rem lh2 fw500 tac">Billing <span className="c4">History</span></h1>
					{/* <p className="w100 fs1rem mt0-5rem lh2 c2 fw400 tac">Choose the right Diligentsia Plan for you</p> */}
				</div>
				<div className='df fdc ais w90'>
					{
						loading ? <div className="df aic jcc w100 h100">
							<h1 className='tac c15 fs1-75rem pt1rem py3rem lh2'>Loading...</h1>
						</div> : <>
							{companies && companies.length > 0
								? <>
									{companies.map((company, idx) => {
										return <React.Fragment key={`${company['_id']}-${idx}`}>
											<BillingCard company={company} idx={idx} />
										</React.Fragment>
									})
									}
								</>
								: <h1 className='tac c15 fs1-75rem pt1rem py3rem lh2'>No Companies Added</h1>
							}
						</>
					}


				</div>
			</div>
		</AnimatedPage>
	);
};